import { __decorate } from "tslib";
import { Component, ViewEncapsulation } from '@angular/core';
import { SharedHttp } from '../../../services/http-client.service';
import { WebsiteThemeService } from '../../../services/website-theme.service';
import { DomSanitizer } from '@angular/platform-browser';
import { WebClientService } from "../../../services/webclient-settings.service";
import { ComponentService } from "../../../services/component.service";
import { ChangeWalletPasswordComponent } from "../change-wallet-password";
import { ActivatedRoute } from "@angular/router";
/**
 * Data Component
 */
let DataComponent = class DataComponent {
    constructor(httpClient, sanitizer, themeService, webSettingsService, compService, route) {
        this.httpClient = httpClient;
        this.sanitizer = sanitizer;
        this.themeService = themeService;
        this.webSettingsService = webSettingsService;
        this.compService = compService;
        this.route = route;
        this.userData = {};
        this.bankAccounts = [];
        this.cryptoAccounts = [];
        this.notifications = {};
        this.updateNotifications = {};
        this.changed = false;
        this.mainColor = '';
        this.borderRadiusSmaller = '';
        this.borderRadiusLarger = '';
        this.textColor = '';
        this.accentColor = '';
        this.tokenError = false;
        this.walletPasswordChangeMessage = '';
        this.resendEmailSent = false;
        this.themeService.getTheme().subscribe((data) => {
            this.mainColor = this.themeService.getStyleAttribute('main_color');
            this.borderRadiusSmaller = this.themeService.getStyleAttribute('border_radius_smaller');
            this.borderRadiusLarger = this.themeService.getStyleAttribute('border_radius_larger');
            this.textColor = this.themeService.getStyleAttribute('text_color');
            this.accentColor = this.themeService.getStyleAttribute('accent_color');
        });
        this.route.params.subscribe((params) => {
            this.token = params['token'];
        });
        if (this.token) {
            this.httpClient.get('user/resetpasswordconfirm/' + this.token).subscribe((data) => {
                this.compService.openModal(ChangeWalletPasswordComponent, {
                    token: this.token,
                    step: 3
                }, (success) => {
                    this.walletPasswordChangeMessage = 'success';
                }, (error) => {
                    this.walletPasswordChangeMessage = 'error';
                });
            }, (error) => {
                this.tokenError = true;
            });
        }
    }
    ngOnInit() {
        localStorage.removeItem('draftData');
        this.httpClient.get('user/data').subscribe((data) => {
            this.userData = data;
            this.userData.password = 'necesmajci';
            if (this.userData.ispep === 0) {
                this.isPep = true;
            }
            else {
                this.isPep = false;
            }
        });
        this.httpClient.get('user/getselectednotifications').subscribe((result) => {
            this.notifications = result;
            this.updateNotifications = this.notifications;
        });
        this.httpClient.get('user/getbankaccounts').subscribe((result) => {
            this.bankAccounts = result;
        });
        this.httpClient.get('user/getcryptoaddresses').subscribe((result) => {
            this.cryptoAccounts = result;
        });
    }
    updatePep() {
        this.httpClient.post('user/changepepstatus', {
            is_pep: this.isPep ? 0 : 1
        }).subscribe((data) => {
            this.changed = true;
            setTimeout(function () {
                this.changed = false;
            }.bind(this), 3000);
        });
    }
    openChangeWalletPasswordModal() {
        this.compService.openModal(ChangeWalletPasswordComponent, { step: 1 });
    }
    resendEmail() {
        this.httpClient.post('wallet/forgotpassphrase', { fromWallet: false }).subscribe();
        this.tokenError = false;
        this.resendEmailSent = true;
    }
};
DataComponent.ctorParameters = () => [
    { type: SharedHttp },
    { type: DomSanitizer },
    { type: WebsiteThemeService },
    { type: WebClientService },
    { type: ComponentService },
    { type: ActivatedRoute }
];
DataComponent = __decorate([
    Component({
        selector: 'ecd-data',
        encapsulation: ViewEncapsulation.None,
        template: __importDefault(require("./data.component.html")).default
    })
], DataComponent);
export { DataComponent };
